import { Box, Button, Dialog, DialogContent, makeStyles } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import DialogTitleBlock from '../../../../../../../components/Modals/Dialog/DialogTitleBlock';
import SearchSummaryTable from '../../../../SearchSummaryTable/SearchSummaryTable';

export interface Props {}

const SearchSummary: React.FC<Props> = () => {
  const classes = useStyles();
  const anchorRef = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <Box className={`${classes.rightBox}`}>
      <Button
        className={classes.button}
        aria-controls="customized-menu"
        ref={anchorRef}
        aria-haspopup="true"
        variant="contained"
        color="primary"
        onClick={() => setOpen(true)}
      >
        {t('searchSummary:title')}
      </Button>
      <Dialog maxWidth="md" fullWidth={true} onClose={() => setOpen(false)} open={open}>
        <DialogTitleBlock
          icon={<SearchIcon />}
          title={t('searchSummary:title')}
          handleClose={() => setOpen(false)}
        />
        <DialogContent dividers>
          <SearchSummaryTable />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  rightBox: {
    display: 'flex',
  },
  button: {
    background: theme.palette.primary.dark,
    borderLeft: `1px solid ${theme.palette.background.paper}`,
    borderRadius: 0,
    lineHeight: '95%',
  },
  progressBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default SearchSummary;
